import {GetterTree} from "vuex";
import {PoolsState} from "@/store/settings/pools/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<PoolsState, RootState> = {
  pools:state => state.pools,
  poolItem:state => state.poolItem,
}